var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative form-base", attrs: { id: "form-base" } },
    [
      _c(
        "div",
        {
          staticClass:
            "sticky top-0 z-10 flex items-center w-full h-12 px-6 lg:w-auto bg-slate-200"
        },
        [
          _c(
            "router-link",
            { attrs: { to: "/center/client-acquisition/form" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center text-2xl font-bold font-logo text-light-purple"
                },
                [_vm._v("\n        Blüm\n      ")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.fetchLoading
        ? _c("div", { staticClass: "grid form-body place-items-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center text-4xl font-bold font-logo text-light-purple animate-pulse"
              },
              [_vm._v("\n      Blüm Form\n    ")]
            )
          ])
        : !_vm.parentForm
        ? _c("div", { staticClass: "grid px-4 form-body place-items-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col items-center w-full gap-2 px-4 py-5 border-l-8 shadow-lg lg:w-148 lg:px-10 bg-pure-white border-red-cherry rounded-xl"
              },
              [
                _c("BlTextTitle4", { attrs: { text: "404: Form Not Found" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  staticClass: "text-center",
                  attrs: {
                    text:
                      "It looks like the form you're trying to reach doesn't exist or the URL is incorrect. Please check the URL."
                  }
                })
              ],
              1
            )
          ])
        : _c("div", { staticClass: "w-full" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col items-center w-full gap-5 px-4 py-4 lg:py-5"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col w-full gap-2 px-4 py-5 border-l-8 lg:w-148 lg:px-10 bg-pure-white border-light-purple-200 rounded-xl"
                  },
                  [
                    _c("BlTextTitle4", {
                      attrs: { text: _vm.parentForm.name }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "whitespace-pre-line text-slate-800",
                      attrs: { text: _vm.parentForm.description }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        { staticClass: "flex gap-1 px-1 rounded bg-tulip-100" },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "user-square", color: "tulip-7" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-tulip-700",
                                attrs: { text: "This form is for " }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle3", {
                                staticClass: "text-tulip-700",
                                attrs: { text: "Prospect Name" + "'s" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-tulip-700",
                                attrs: {
                                  text: " guardian. Please submit it before "
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle3", {
                                staticClass: "text-tulip-700",
                                attrs: { text: "Expiration Date." }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.currentSection
                  ? _c("ProspectFormSection", {
                      key: _vm.currentSection.id,
                      attrs: { section: _vm.currentSection }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.currentSection
              ? _c(
                  "div",
                  {
                    staticClass:
                      "sticky bottom-0 left-0 flex flex-col w-screen h-32 gap-2 px-6 py-4 border-t lg:h-22 lg:flex-row lg:items-center lg:justify-between bg-pure-white border-slate-400"
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2 mb-2" },
                        _vm._l(_vm.parentFormSections, function(section) {
                          return _c(
                            "div",
                            {
                              key: section.id,
                              staticClass:
                                "relative flex-shrink-0 w-10 h-1 transition-all duration-300 rounded lg:w-32",
                              class: [
                                _vm.currentSection.position >= section.position
                                  ? "bg-lime-400"
                                  : "bg-slate-400"
                              ]
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "absolute z-10 h-1 transition-all duration-300 rounded bg-lime-600",
                                style: {
                                  width:
                                    (_vm.getAnsweredCount(section.id) * 100) /
                                      section.questions.length +
                                    "%"
                                }
                              })
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-1" },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-700",
                            attrs: { text: _vm.currentSection.name }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Questions filled in this section: " +
                                _vm.getAnsweredCount(_vm.currentSection.id) +
                                "/" +
                                _vm.currentSection.questions.length
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-row items-center gap-4" },
                      [
                        !_vm.isFirstSection
                          ? _c("BlInputButton", {
                              staticClass: "flex-grow",
                              attrs: {
                                type: "outlined",
                                dense: _vm.viewMode !== "desktop",
                                label: "Back"
                              },
                              on: {
                                clicked: function($event) {
                                  return _vm.onNextSection(-1)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isLastSection
                          ? _c("BlInputButton", {
                              staticClass: "flex-grow",
                              attrs: {
                                type: "outlined",
                                dense: _vm.viewMode !== "desktop",
                                label: "Next"
                              },
                              on: {
                                clicked: function($event) {
                                  return _vm.onNextSection(1)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLastSection
                          ? _c(
                              "router-link",
                              {
                                attrs: { to: "/center/client-acquisition/form" }
                              },
                              [
                                _c("BlInputButton", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    label: "Submit",
                                    dense: _vm.viewMode !== "desktop",
                                    loading: _vm.submitLoading
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b98cbd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b98cbd9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/salesPipeline/FormPreview.vue
// module id = null
// module chunks = 